module.exports = __webpack_public_path__ + "img/Raspberry32_128.e05d2b6e.png";